import type { i18n } from 'i18next'
import { LANGUAGE_STORAGE_KEY, createI18n, resolveLanguage } from '@dorixona/i18n'

/** Staff pick their language; the browser decides only on the first visit. */
export function createAppI18n(
  storage: Pick<Storage, 'getItem'> = localStorage,
  navigatorLanguage: string = navigator.language,
): i18n {
  const language = resolveLanguage([storage.getItem(LANGUAGE_STORAGE_KEY), navigatorLanguage])
  return createI18n({ language })
}
